// Saufdings login gRPC backend URL, used by dowtex's auth flow.
//
// Resolution order is runtime env.js value -> CRA build-time override -> production URL.
// Empty values fall through so a misconfigured deployment cannot issue requests to an empty URL.
import { resolveGrpcBackendUrl, runtimeValue } from '@dowty/core';

const GRPC_BACKEND_URL = resolveGrpcBackendUrl(
  runtimeValue('GRPC_BACKEND_URL'),
  process.env.REACT_APP_DOWTEX_GRPC_BACKEND_URL,
  'https://saufdingsapitoo.dowtex.com',
);

export default GRPC_BACKEND_URL;
